import React from "react";
import { BrowserRouter, Switch, Route } from "react-router-dom";
import { UserProvider } from "../Context/UserContext";
import {
    Home,
    NotMatch,
    HowTo,
    Prestadores,
    PerfilPrestador,
    Login,
    LoginUsuarios,
    LoginPrestadores,
    Registro,
    RegistroPrestadores,
    RegistroUsuarios,
    Legal,
    Privacy,
    ComoFuncionaPrestadores,
    ComoFuncionaUsuarios,
    ArticlePage,
    Articulos,
    HowToUsers,
    Terms,
    Contact,
    InformacionParaPrestadores
} from "../pages";


const app = () => {



    return (
        <UserProvider>
            <BrowserRouter>
                <Switch>
                    <Route exact path="/" component={Home} />
                    <Route exact path="/prestadores" component={Prestadores} />
                    <Route exact path="/prestador/perfil" component={PerfilPrestador} />
                    <Route exact path="/quiénes-somos" component={HowTo} />
                    <Route exact path="/blog" component={Articulos} />
                    <Route exact path="/login" component={Login} />
                    <Route exact path="/login/usuarios" component={LoginUsuarios} />
                    <Route exact path="/login/prestadores" component={LoginPrestadores} />
                    <Route exact path="/registro" component={Registro} />
                    <Route exact path="/registro/usuarios" component={RegistroUsuarios} />
                    <Route exact path="/registro/prestadores" component={RegistroPrestadores} />
                    <Route exact path="/aviso-legal" component={Legal} />
                    <Route exact path="/política-de-privacidad" component={Privacy} />
                    <Route exact path="/como-funciona-prestadores" component={ComoFuncionaPrestadores} />
                    <Route exact path="/información-para-prestadores" component={InformacionParaPrestadores} />
                    <Route exact path="/como-funciona-usuarios" component={HowToUsers} />
                    <Route exact path="/términos-y-condiciones" component={Terms} />
                    <Route exact path="/contacto" component={Contact} />
                    <Route exact path="/:title" component={ArticlePage} />
                    <Route component={NotMatch} />
                </Switch>
            </BrowserRouter>
        </UserProvider>
    )
}

export default app;
